import { render, staticRenderFns } from "./InputSelectNew.vue?vue&type=template&id=134dc7fe&"
import script from "./InputSelectNew.vue?vue&type=script&lang=js&"
export * from "./InputSelectNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports